import * as actionType from "../types/ActionTypes";

const initialState = {
  courseByEvents: [],
  error: false,
  isLoading: false,
};

export const CourseByEvents = (state = initialState, action) => {
  switch (action.type) {
    case actionType.COURSE_BY_EVENTS_SET_DATA:
      return {
        ...state,
        courseByEvents: action.courseByEvents,
        error: false,
        isLoading: false,
      };

    case actionType.COURSE_BY_EVENTS_FAIL_DATA:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case actionType.COURSE_BY_EVENTS_LOADING:
      return {
        ...state,
        isLoading: true,
        error: false,
      };

    default:
      return state;
  }
};
